export default "__VITE_ASSET__BllLEiMN__"